import Vue from 'vue'
import * as Raven from 'raven-js'
import * as RavenVue from 'raven-js/plugins/vue'

import getSession from '@/api/session'
import * as helper from '@/api/helper'

import dic from '@/constants/pf-dictionary'
import App from './App.vue'
import router from './router'
import './filter'
import Report from './plugins/report'

import '../ui/assets/mobile/css/swiper.min.css'
import '../new_ui/css/main.css'

Vue.config.productionTip = false

/* eslint-disable no-console */
Raven.config('https://ba1338cb6a054eb49d53fe4dd2469856@report.url.cn/sentry/435', {
  environment: process.env.NODE_ENV,
  release: process.env.VERSION,
  dataCallback(data) {
    if (process.env.NODE_ENV !== 'production') {
      console.log(data)
    }

    return data
  },
  shouldSendCallback() {
    return process.env.NODE_ENV === 'production'
  }
})
  .addPlugin(RavenVue, Vue)
  .install()

const initVueInstance = (openid: string) => {
  Vue.use(Report, { openid })
  // 方便在模板中使用 pf-dictionary
  Vue.prototype.dic = dic

  // eslint-disable-next-line no-new
  new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
  })
}

/**
 * 获取用户登录态
 * 并渲染页面及Report模块
 */
/* eslint-disable no-underscore-dangle  */
const session = getSession()
let openid = ''
if (session !== null) {
  helper.initApi(session)
  openid = session.getSessionParam().openid
} else {
  Raven.captureException('error in get session', {
    time: new Date().toLocaleString(),
    wxinfo: {
      info1: window._wxinfo1,
      info2: window._wxinfo2
    }
  } as any)
}
initVueInstance(openid)
